import { addDays, format } from "date-fns";

// Status einer Bestellung, wie ihn das Terminal setzt.
export const orderStatus = (order) => {
    if (order.accepted) return "bestaetigt";
    if (order.denied) return "abgelehnt";
    return "offen";
};

export const ORDER_STATUS = {
    offen: { label: "Offen", className: "border-messing text-messing" },
    bestaetigt: { label: "Bestätigt", className: "border-erfolg text-erfolg" },
    abgelehnt: { label: "Abgelehnt", className: "border-fehler text-fehler" },
};

export const ORDER_FILTERS = [
    ...Object.entries(ORDER_STATUS).map(([id, { label }]) => [id, label]),
    ["alle", "Alle"],
];

// Nach Status filtern ("alle" = keine Einschränkung), neueste zuerst.
export const filterOrders = (orders, filter) =>
    orders
        .filter((order) => filter === "alle" || orderStatus(order) === filter)
        .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

export const RESERVATION_FILTERS = [
    ["heute", "Heute"],
    ["woche", "7 Tage"],
    ["alle", "Alle"],
];

// Query für GET /admin/reservation. "alle" = ab heute ohne Ende.
export const reservationQuery = (filter, today = new Date()) => {
    const von = format(today, "yyyy-MM-dd");
    if (filter === "heute") return { von, bis: von };
    if (filter === "woche") return { von, bis: format(addDays(today, 6), "yyyy-MM-dd") };
    return { von };
};

// Der Drucker meldet sich regelmäßig; wie im Backend gilt er bis 30 s danach als online.
export const PRINTER_TIMEOUT_MS = 30000;

export const isPrinterOnline = (lastPing, now = new Date()) => {
    if (!lastPing) return false;
    const last = new Date(lastPing).getTime();
    return !Number.isNaN(last) && now.getTime() - last <= PRINTER_TIMEOUT_MS;
};

// Element an Position index um dir (-1/+1) verschieben; am Rand dieselbe Liste.
export const moveInList = (list, index, dir) => {
    const target = index + dir;
    if (target < 0 || target >= list.length) return list;
    const next = [...list];
    [next[index], next[target]] = [next[target], next[index]];
    return next;
};
